import { render, staticRenderFns } from "./HorizontalBannersEdit.vue?vue&type=template&id=254c495f&scoped=true"
import script from "./HorizontalBannersEdit.vue?vue&type=script&lang=js"
export * from "./HorizontalBannersEdit.vue?vue&type=script&lang=js"
import style0 from "./HorizontalBannersEdit.vue?vue&type=style&index=0&id=254c495f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254c495f",
  null
  
)

export default component.exports